export const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
] as const;

export type WeekDay = (typeof weekDays)[number];

export const lastDayOfTheMonth = -1;
export const daysOfTheMonth = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28,
] as const;

export type LastDayOfTheMonthType = typeof lastDayOfTheMonth;
export type DayOfTheMonthType = typeof daysOfTheMonth;

export type TimeZoneName = string;

export const ScheduleExportFrequencies = [
  "DAILY",
  "WEEKLY",
  "MONTHLY",
] as const;

export type ScheduleExportFrequencyType =
  (typeof ScheduleExportFrequencies)[number];

interface BaseScheduleTimeFrame {
  frequency: ScheduleExportFrequencyType;
  time: string; // Format: 'HH:MM:SS'
  timezone: TimeZoneName;
}

export interface DailyScheduleTimeFrame extends BaseScheduleTimeFrame {
  frequency: "DAILY";
}

export interface WeeklyScheduleTimeFrame extends BaseScheduleTimeFrame {
  frequency: "WEEKLY";
  weekDay: WeekDay;
}

export interface MonthlyScheduleTimeFrame extends BaseScheduleTimeFrame {
  frequency: "MONTHLY";
  dayOfTheMonth: DayOfTheMonthType | LastDayOfTheMonthType;
}

export type ScheduleTimeFrame =
  | DailyScheduleTimeFrame
  | WeeklyScheduleTimeFrame
  | MonthlyScheduleTimeFrame;
